/// <reference types="vite/client" />
var env;
var CLOUDFLARE_ACCOUNT_HASH = 'pKRqk_cgZfGOj9FgBNYyVA'; // In vite mode, process.env.NODE_ENV exists but process is undefined
// In nextJs mode, 'process.env.TEST' is text replaced to whatever the value is in env variables and process is defined

if (typeof process !== 'undefined') {
  if (process.env.NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH) CLOUDFLARE_ACCOUNT_HASH = process.env.NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH;
} else if (import.meta !== undefined) {
  env = import.meta.env;
  if (env.VITE_PUBLIC_CLOUDFLARE_ACCOUNT_HASH) CLOUDFLARE_ACCOUNT_HASH = env.VITE_PUBLIC_CLOUDFLARE_ACCOUNT_HASH;
} else {
  throw 'No env found';
}

export { CLOUDFLARE_ACCOUNT_HASH };